module.exports = __webpack_public_path__ + "static/form-input-masks-do-9e6c24fe4b13e32aba0032c6dce84c5c.png";